module.exports = __webpack_public_path__ + "img/deportivo-la-coruna-logo-icon.59595e8f.webp";